import globalConfig from 'react-global-configuration';

const RETURN_TO = 'returnto';
const TTL = 'ttl';

export function getIdentityEndpoint() {
  return globalConfig.get('identityEndpoint');
}

const getURLParams = () => new URLSearchParams(window.location.search || '');

export const getRedirectTTL = () => getURLParams().get(TTL) || null;

export const canReauthenticate = () => {
  const redirectTTL = getRedirectTTL();

  return !redirectTTL || redirectTTL !== '0';
};

export default function identityReauthenticateRedirect() {
  if (!canReauthenticate()) {
    // throw new Error('The redirect TTL is 0. Redirection stopped.');
    return;
  }

  const returnTo = window.location.href;
  const returnToMinusProtocol = returnTo.replace(/^https?:\/\//, '');
  const url = new URL('', returnTo);
  const queryParams = new URLSearchParams(url.search);

  queryParams.set(RETURN_TO, returnToMinusProtocol);
  queryParams.set(TTL, '1');

  window.location.href = new URL(`?${queryParams.toString()}`, getIdentityEndpoint()).href;
}